export const T = {
  navy:        '#0D1B2A',
  navyMid:     '#162436',
  navyLight:   '#1E3048',
  navyDeep:    '#0A1520',
  gold:        '#C9A84C',
  goldLight:   '#E8C96A',
  goldPale:    '#F5E9C8',
  teal:        '#1A7F8E',
  tealLight:   '#22A0B2',
  tealPale:    '#E6F4F6',
  slate:       '#3A4A5C',
  muted:       '#6B7A8D',
  softGrey:    '#9EACBE',
  border:      '#E2E8F0',
  surface:     '#F8FAFC',
  white:       '#FFFFFF',
  bg:          '#F0F4F8',
  success:     '#1A7A4A',
  successPale: '#EAF7EE',
  warning:     '#E07B00',
  warningPale: '#FEF5E7',
  danger:      '#C0392B',
  dangerPale:  '#FDECEA',
  purple:      '#6B46C1',
  purplePale:  '#F3EEFF',
  pink:        '#B83280',
  pinkPale:    '#FDE8F5',
};

export const FONTS = {
  display: "'Cormorant Garamond', Georgia, serif",
  body:    "'DM Sans', -apple-system, sans-serif",
  mono:    "'DM Mono', monospace",
};

export const SHADOW = {
  sm:  '0 1px 3px rgba(0,0,0,.08)',
  md:  '0 4px 16px rgba(0,0,0,.10)',
  lg:  '0 8px 32px rgba(0,0,0,.14)',
  xl:  '0 16px 48px rgba(0,0,0,.18)',
};
